import DepartmentsModel from 'models/DepartmentsModel';

DepartmentsStore.dispatchToken = MakeShiftEmployeeDispatcher.register(
  DepartmentsStore.dispatchCallback,
);

DepartmentsStore.getDepartmentById = function (departmentId) {
  let dept = DepartmentsStore.get(departmentId);
  if (!Utils.isNotDefined(dept)) {
    dept = dept.present();
  }
  return dept;
};

DepartmentsStore.onDepartmentHandler = function (data, response, options) {
  DepartmentsStore.trigger('load:success', data, response, options.data.target);
};

DepartmentsStore.onDepartmentError = function (data) {
  DepartmentsStore.trigger('load:error', data);
};

DepartmentsStore.onDepartmentScheduleHandler = function (data, response) {
  DepartmentsStore.trigger('schedule:load:success', data, response);
}

DepartmentsStore.onDepartmentScheduleError = function (data) {
  DepartmentsStore.trigger('schedule:load:error', data);
};
